import React from "react";
import { canv } from "@/canv/global";
import { normalizeImageUrl } from "@/canv/utils";
import type { ImageWidget } from "../types";
import style from "./imageResult.module.css";

export function ImageResult({ widgetData }: { widgetData: ImageWidget }) {
    const url = new URL(widgetData.imageUrl);
    const token = canv.getInitDataProp("boardAccessToken");
    if (token) {
        url.searchParams.set("boardAccessToken", token);
    }
    return <img src={normalizeImageUrl(url.href)} alt="" className={style.candidateItemViewImg} />;
}
